export default "__VITE_ASSET__lYRDvmfg__"